/**
 * Password reset for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
 */
'use strict';

import {showErrorsOnForm, showFlash} from "./utils";
import {addNewUser, sendEditedFormData} from "./crypto";

export function setupForgotPassword() {
    setupForgot().then(() => {});
}


/**
 *
 */
async function setupForgot() {

    const form = document.getElementById('passwordForgotForm') as HTMLFormElement;
    if (!form) {
        return;
    }

    console.log('forgot')

    const repeatPassword = document.getElementById('repeat_password') as HTMLInputElement;
    const newPassword = document.getElementById('password') as HTMLInputElement;


    form.addEventListener('submit', async (event) => {
        event.preventDefault()

        if (repeatPassword.value !== newPassword.value) {
            showFlash('Passwords must match', 'info')
            return;
        }
        if (newPassword.value === '') {
            showFlash('Password cannot be empty', 'info')
            return;
        }


        addNewUser(newPassword.value).then(userResult => {
            let data = new FormData(form);

            data.set("password", userResult.scryptHashedPassword);
            data.set("repeat_password", userResult.scryptHashedPassword);
            data.set("public_key", userResult.publicKey);
            data.set("encrypted_private_key", (new Uint8Array(userResult.privateKey)).toString());
            data.set("iv", userResult.iv.toString());
            data.set("salt", userResult.salt.toString());
            data.set("hkdf_salt", userResult.hkdfSalt);
            data.set("scrypt_salt", userResult.scryptSalt);

            sendEditedFormData(form.action, data, 'PUT', function (request, response) {
                if (request.status === 200) {
                    if (window.location.pathname.includes('/de/')) {
                        window.location.href = '/de'
                    } else if (window.location.pathname.includes('/fr/')) {
                        window.location.href = '/fr'
                    } else {
                        window.location.href = '/'
                    }
                } else {
                    showErrorsOnForm(response.response)
                }
            });
        });

    });
}